import React, { useEffect, useState } from "react";

// ASSETS

// STYLES

// LIBRARIES
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { CenterWrapper, Circle, SliderWrapper } from "./AlertsCarouselStyled";
import { useTranslation } from "react-i18next";

// MISC
import useWindowWidth from "hooks/useWindowWidth";
import { ConsultationResponse, SliderProps } from "./AlertsCarouselModel";

// REDUX

// COMPONENTS
import AlertsCarouselItem from "components/AlertsCarouselItem/AlertsCarouselItem";
import homeService from "services/homeService";

const CarouselSlider: React.FC<SliderProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [currentSlide, setCurrentSlide] = useState(0);
  const windowWidth = useWindowWidth();
  const [alerts, setAlerts] = useState<ConsultationResponse>();
  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    // setLoading(true);
    homeService
      .getNewsArticles(true)
      .then((data) => {
        // console.log("getNewsArticles response", data);
        setAlerts(data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, []);

  // EVENT HANDLERS
  const settings = {
    customPaging: function (i) {
      return <Circle active={i === currentSlide} />;
    },
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: windowWidth < 1300 ? 1 : 3,
    slidesToScroll: 1,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
  };

  return (
    <SliderWrapper>
      <CenterWrapper>
        {alerts?.data?.length && (
          <Slider centerMode={false} {...settings}>
            {alerts.data.map((item, index) => (
              <div key={index}>
                <AlertsCarouselItem
                  title={t("components.carouselSlider.antet")}
                  body={item?.attributes?.title}
                  date={item?.attributes?.publishedAt}
                  id={item?.id}
                />
              </div>
            ))}
          </Slider>
        )}
      </CenterWrapper>
    </SliderWrapper>
  );
};

export default CarouselSlider;
